/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataLeadCard, DataLeadPerState } from '@interfaces';
import { TrackLeadDialogComponent } from '../dialogs/track-lead-dialog/track-lead-dialog.component';
import { IconName } from 'nanaykuna-ui-kit/loader';
import { OrderService } from '@services';
import { HttpErrorResponse } from '@angular/common/http';
import { formatTextStyle, getChannelLabel } from '@utils';

@Component({
  selector: 'unicon-track-lead-card',
  templateUrl: './track-lead-card.component.html',
})
export class TrackLeadCardComponent {
  @Input() order?: any;
  @Input() listCard?: DataLeadPerState;
  @Input() listCardChat?: any;
  @Input() viewTab?: string;
  @Input() onShowChatView!: (order: DataLeadCard) => void;
  @ViewChild('pinAlertButton') pinAlertButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('frameAlertButton')
  frameAlertButton!: ElementRef<HTMLButtonElement>;
  protected error: string = '';
  protected width: number = 0;
  protected elapsedTime: string = '';
  protected diffTime: number = 0;
  private intervalId: any;
  protected lastSessionTime: boolean = false;
  protected elapsedTimeText: boolean = true;
  protected showElapsedTimeText: boolean = true;

  constructor(
    private dialog: MatDialog,
    private orderService: OrderService,
  ) {}

  ngOnInit(): void {
    this.calculateElapsedTime();

    this.intervalId = setInterval(() => {
      this.calculateElapsedTime();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  protected getChannelNameLabel(): string {
    return getChannelLabel(this.order?.channelName);
  }

  protected getPrincipalText(lead: DataLeadCard): string {
    if (lead.leadCompleteName) {
      return lead.leadCompleteName;
    }

    return lead.leadContactCode;
  }

  protected readMessagesInChat(orderId: string) {
    this.orderService.updateReadMessages(orderId).subscribe();
  }

  protected onTabViewClick() {
    if (this.order) {
      if (this.viewTab === 'view-chat-lead') {
        this.onShowChatView(this.order);
        if (this.order && this.order.orderId && !this.order.isRead) {
          this.readMessagesInChat(this.order.orderId);
        }
      } else {
        this.onChatClick(this.order);
      }
    }
  }

  protected onChatClick(lead: DataLeadCard): void {
    if (this.order && this.order.orderId && !this.order.isRead) {
      this.readMessagesInChat(this.order.orderId);
    }

    this.dialog.open(TrackLeadDialogComponent, {
      data: { listCard: this.listCard?.items, lead: lead },
      disableClose: false,
      autoFocus: false,
      width: 'auto',
      height: 'auto',
      panelClass: 'track-lead-dialog',
    });
  }

  protected onAction(action: string): void {
    switch (action) {
      case 'see-details':
        if (this.order) {
          this.onChatClick(this.order);
        }
        break;
    }
  }

  protected stopPropagation(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  protected getChannelIcon(channel: string): IconName {
    const values: Record<string, IconName> = {
      whatsapp: 'whatsapp',
      facebook: 'facebook',
      messenger: 'facebook',
      phone: 'phone',
    };
    if (values[channel]) {
      return values[channel];
    }

    return 'bug-beetle';
  }

  protected getPriorityText(priority: number): string {
    const priorityText: Record<string, string> = {
      priority1: 'Regular',
      priority2: 'Alta',
      priority3: 'Muy Alta',
    };

    return priorityText['priority' + priority];
  }

  protected getInitials(fullName: string): string {
    const slices: string[] = fullName.split(' ');
    return slices[0][0] + (slices[1] ? slices[1][0] : '');
  }

  protected onClosingProbability(event: MouseEvent, orderId: string): void {
    this.stopPropagation(event);
    this.orderService.updateClosingProbability(orderId).subscribe();
  }

  protected onPin(event: MouseEvent, orderId: string): void {
    this.stopPropagation(event);
    this.orderService.togglePinOrder(orderId).subscribe({
      error: (error: HttpErrorResponse) => {
        this.error = error.error.detail;
        const btn: HTMLButtonElement = this.pinAlertButton.nativeElement;
        btn.click();
      },
    });
  }

  protected onFrame(event: MouseEvent, orderId: string): void {
    this.stopPropagation(event);
    this.orderService.togglePFrameOrder(orderId).subscribe({
      error: (error: HttpErrorResponse) => {
        this.error = error.error.detail;
        const btn: HTMLButtonElement = this.frameAlertButton.nativeElement;
        btn.click();
      },
    });
  }

  private calculateElapsedTime() {
    if (this.order && this.order.lastLeadSentMessageDateTime) {
      this.lastSessionTime =
        this.order.unansweredMessageCount > 0 ? true : false;
      const lastMessageDate = new Date(this.order.lastLeadSentMessageDateTime);
      const now = new Date();
      const diffInMs = now.getTime() - lastMessageDate.getTime();

      this.diffTime = diffInMs;

      if (diffInMs >= 1000) {
        const hours = Math.floor(diffInMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

        this.elapsedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      } else {
        this.elapsedTime = ''; // No mostrar nada
      }
    }
  }

  protected getColorIcon() {
    if (this.diffTime == null) return 'neutrals-900'; // por defecto

    const hours = Math.floor(this.diffTime / (1000 * 60 * 60));

    if (hours < 24) {
      this.showElapsedTimeText = true;
      this.elapsedTimeText = hours >= 23 ? false : true;
      return 'neutrals-900';
    } else if (hours >= 24) {
      this.showElapsedTimeText = false;
      this.elapsedTimeText = true;
      return 'critical-300';
    }

    return 'neutrals-900';
  }

  protected formatText(text: string): string {
    text = formatTextStyle(text);

    return text;
  }
}
